import { Chip, ChipProps, chipClasses } from '@mui/material';

const StatusChip = ({ sx, ...props }: ChipProps) => {
  return (
    <Chip
      sx={{
        height: '25px',
        padding: '8px',
        borderRadius: '32px',
        [`& .${chipClasses.label}`]: {
          padding: '0 2px',
          fontSize: 12,
          fontWeight: 500,
        },
        [`& .${chipClasses.icon}`]: {
          width: '14px',
          margin: 0,
          color: 'currentcolor',
        },
        ...sx,
      }}
      role='presentation'
      {...props}
    />
  );
};

export default StatusChip;
